document.addEventListener('DOMContentLoaded', function () {
   initializeScrollButtons(); 
    updateActiveThumbnail();
    
  
});

function updateActiveThumbnail() {
    // Get the active media item|
    
    const activeMediaItem = document.querySelector('.product__media-item.is-active');
    if (!activeMediaItem) return; // Exit if no active media item

    // Get its data-group-value
    const groupValue = activeMediaItem.getAttribute('data-group-value');
    const slideWidth = document.querySelector('.thumbnail-list.slider--tablet-up .thumbnail-list__item.slider__slide');
   

    // Select all thumbnail list items
    const thumbnailItems = document.querySelectorAll('.thumbnail-list li');

    // Loop through each <li> element
    thumbnailItems.forEach(item => {
        // Get the data-group-value attribute
        const dataGroupValue = item.getAttribute('data-group-value');

        // Add or remove the active-thumb-images class based on match
        if (dataGroupValue === groupValue) {
            item.classList.add('active-thumb-images');
        } else {
            item.classList.remove('active-thumb-images');
        } 
    });  
    const activeThumbLength = document.querySelectorAll('.active-thumb-images').length;
    const sliderButtons = document.querySelectorAll('.thumbnail-slider .slider-button'); // Select all slider buttons
    console.log(activeThumbLength);
    
    if (activeThumbLength <= 5) {
        // Disable all slider buttons
        sliderButtons.forEach(button => button.classList.add("deactive"));
    } else {
        // Enable all slider buttons
        sliderButtons.forEach(button => button.classList.remove("deactive"));
    }


}




function initializeScrollButtons() {

   const leftButton = document.querySelector('.scroll-button.left');
   const rightButton = document.querySelector('.scroll-button.right');
   const productList = document.querySelector('.color-image-scroll');
   const outerProductList =document.querySelector('.color-image-products-list');
  if (productList && outerProductList ) {
      const productListWidth = productList.offsetWidth;
      const outerProductListWidth = outerProductList.offsetWidth;
  
      // Compare the widths
      if (productListWidth < outerProductListWidth) {
          // Hide the scroll button if the condition is met
          leftButton.style.display = 'none';
          rightButton.style.display = 'none';
      } else {
          // Optionally, show the scroll button if the condition is not met
           leftButton.style.display = 'block';
          rightButton.style.display = 'block';
      }
  }

   if (productList && leftButton && rightButton) {
      // Remove any existing event listeners by cloning the buttons
      leftButton.replaceWith(leftButton.cloneNode(true));
      rightButton.replaceWith(rightButton.cloneNode(true));

      // Re-select the buttons after cloning
      const newLeftButton = document.querySelector('.scroll-button.left');
      const newRightButton = document.querySelector('.scroll-button.right');

      // Attach new click event listeners
      newLeftButton.addEventListener('click', () => {
         //console.log('Scrolling left');
         productList.scrollBy({ left: -200, behavior: 'smooth' });
         // productList.scrollLeft -= 107; 
         //console.log('New scrollLeft:', productList.scrollLeft);
      });

      newRightButton.addEventListener('click', () => {
         //console.log('Scrolling right');
         // productList.scrollLeft += 200; // Scroll right by 200px
         productList.scrollBy({ left: 107, behavior: 'smooth' });
         //console.log('New scrollLeft:', productList.scrollLeft);
      });
      //console.log("Scroll buttons initialized");
   } else {
      console.error('Scroll buttons or product list not found');
   }
}
